module.exports = __webpack_public_path__ + "static/media/manager.31cd8fe3.svg";